<template>
  <div>
    {{ getFolderName(folder) }} :
    <span v-if="nbLinks">
      {{ nbLinks }}
      {{ plural("lien", nbLinks) }}
      et
    </span>
    {{ nbDocs }}
    {{ plural("document", nbDocs) }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { LetterFileDocumentType } from "../../../dto/letter-file-document.dto";
import { type LetterFileFolderDto } from "../../../dto/letter-file-folder.dto";
import { plural } from "../../../utils/plural";
import { getFolderName } from "./utils";

interface Props {
  folder: LetterFileFolderDto;
}
const props = defineProps<Props>();

const nbDocs = computed(
  () => (props.folder.documents || []).filter(doc => doc.type === LetterFileDocumentType.DEFAULT).length
);
const nbLinks = computed(
  () => (props.folder.documents || []).filter(doc => doc.type === LetterFileDocumentType.URL).length
);
</script>
